import React, { Component } from "react";
// components imports
import BaseCurrency from "./BaseCurrency";
import Currencies from "./Currencies";
import Result from "./Result";

// bootstrap imports
import { Container, Row, Col, Card } from "react-bootstrap";

/*
This component is the parent component for the Converter app,
and holds the entire state of the app, that will be passed to all child components as props.
The app also uses an api for relevant exchange rates*/
export class Converter extends Component {
  state = {
    currencies: ["ZAR", "GBP", "EUR"],
    base: "USD",
    amount: "",
    convertTo: "ZAR",
    result: "",
    date: "",
  };

  // function to select exchange rate currency
  handleSelect = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
        result: null,
      },
      this.calculate
    );
  };

  // function to get amount input value
  handleInput = (e) => {
    this.setState(
      {
        amount: e.target.value,
        result: null,
      },
      this.calculate
    );
  };

  // calculate function
  calculate = () => {
    // api cors headers set up
    var myHeaders = new Headers();
    myHeaders.append("apikey", "UMqfLJx7ezKwo4Lp6vBgQCKt3tP0iLxb");

    var requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: myHeaders,
    };

    const amount = this.state.amount;
    if (amount === isNaN) {
      return;
    } else {
      fetch(
        `https://api.apilayer.com/exchangerates_data/latest?base=${this.state.base}`,
        requestOptions
      )
        .then((res) => res.json())
        .then((data) => {
          // console.log(data);
          const date = data.date;
          const result = (data.rates[this.state.convertTo] * amount).toFixed(2);

          this.setState({
            result,
            date,
          });
        });
    }
  };

  render() {
    // const { currencies, base, amount, result, convertTo, date } = this.state;
    return (
      <div className="converter">
        <Container>
          <Row>
            <Col className="converter-wrapper mt-5 py-5">
              <h1 className="align-self-center mb-3">Currency Converter</h1>
              <Card style={{ width: "30rem" }}>
                <Card.Body>
                  {/* component to display the total */}
                  <Result
                    amount={this.state.amount}
                    base={this.state.base}
                    convertTo={this.state.convertTo}
                    result={this.state.result}
                    date={this.state.date}
                  />
                  <Row>
                    <Col>
                      {/* base currency form  aka "USD"  */}
                      <BaseCurrency
                        amount={this.state.amount}
                        base={this.state.base}
                        handleInput={this.handleInput}
                      />
                      {/* currencies form  aka  ["ZAR", "GBP", "EUR"] */}
                      <Currencies
                        currencies={this.state.currencies}
                        convertTo={this.state.convertTo}
                        result={this.state.result}
                        handleSelect={this.handleSelect}
                      />
                    </Col>
                    {/* forms end */}
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Converter;
